import ludovicaPic from "@/public/images/artists/ludovica.png";
import { Artist } from "@/types/types";

export const ludovica = {
  id: "185",
  name: "Ludovica",
  image: ludovicaPic,
  description: `Ludovica delivers a crisp, earthy timbre with precise control across mid-to-high registers. Her dynamic range creates clarity and impact, making her ideal for pop, electronic, or experimental genres.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fludovica-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 57,
        high: 71,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
